module.exports = __webpack_public_path__ + "img/main_peogeot1.82780c49.jpg";